import { BizLine } from '../types/rewardRecords';
import { string2PositiveInt } from './number';
// R007：推荐供给（3.18）固定入参
export const REC_FLOW_SOURCE = 7;
export const REC_PAGE_NO = 1;
export const REC_DEFAULT_PAGE_SIZE = 10;
export const REC_FALLBACK_LAT_LNG = -1.0;
export const REC_FALLBACK_CITY_ID = 1;
// R007：民宿场景固定 wakeupsource
export const HOMESTAY_WAKEUP_SOURCE = 'homestay_shelves';
/**
 * R007：组装任务完成接口（3.8）入参。
 * 浏览任务完成传 leaderId = 自己的 userId（调用方传入），不传 followerId。
 */
export function buildCompleteParams(base, task, ctx, leaderId, followerId) {
    return {
        // 通用参数与助力任务完成（useAssistAction）保持一致：整体展开基座
        // （userId/token/cityId/locateCityId/lat/lng/uuid/version/platform/source/riskRequest）
        ...base,
        activityId: ctx.activityId ?? 0,
        taskId: string2PositiveInt(task.taskId) ?? 0,
        leaderId,
        followerId
    };
}
/** R007：取 yyyyMMdd 整数（今日 + offsetDays 天） */
function yyyyMMdd(offsetDays) {
    const d = new Date();
    d.setDate(d.getDate() + offsetDays);
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
}
/**
 * R007-fix(问题3)：经纬度归一化 —— 拿不到（空 / NaN / 0）统一传 -1.0。
 * 对齐同仓 city-wish-free-card / team-ranking-free：0 视为「无定位」而非赤道，避免推荐供给定位异常。
 */
function normalizeLatLng(v) {
    return v == null || Number.isNaN(v) || v === 0 ? REC_FALLBACK_LAT_LNG : v;
}
/**
 * R007：组装推荐供给接口（3.18）入参（仅酒店/民宿浏览任务，按标签/供给 id 取个性化 poiId）。
 * 酒店带 supplyGroupId（取 supplyIds[0]）；民宿带 dynamicTagId + dateBegin/dateEnd（今/明日）+ wakeupsource/appVersion。
 * recExtra（utm_* / client / source4Homestay）为 rec 专属客户端核心参数，由 getRecExtraParams 派生后传入，
 * 不走基座（避免误传给其它接口）。
 */
export function buildRecParams(base, task, ctx, recExtra) {
    const extra = (task.extra ?? {});
    const biz = extra.commonExtra?.biz ?? BizLine.Hotel;
    const browseExtra = extra.browseTaskExtra ?? {};
    const isHomeStay = biz === BizLine.HomeStay;
    return {
        biz,
        // 酒店：供给组 id（Long 单值，取供给 id 列表首个）
        ...(biz === BizLine.Hotel ? {
            supplyGroupId: browseExtra.supplyIds?.[0]
        } : {}),
        // 民宿：商品组标签 + 入离日期（今/明日）+ 唤端来源 + 版本
        ...(isHomeStay ? {
            dynamicTagId: browseExtra.dynamicTagIds,
            dateBegin: yyyyMMdd(0),
            dateEnd: yyyyMMdd(1),
            wakeupsource: HOMESTAY_WAKEUP_SOURCE,
            appVersion: base.version
        } : {}),
        flowSource: REC_FLOW_SOURCE,
        pageNo: REC_PAGE_NO,
        pageSize: ctx.recSize ?? REC_DEFAULT_PAGE_SIZE,
        userId: base.userId,
        token: base.token,
        platform: base.platform,
        source: base.source,
        uuid: base.uuid,
        lat: normalizeLatLng(base.latitude),
        lng: normalizeLatLng(base.longitude),
        // cityId 取「用户活动参与城市」（参与中态选中城市），缺省回退端注入预设城市；
        // locateCityId 仍取端注入设备定位城市（base.locateCityId），不随参与城市变。
        cityId: string2PositiveInt(ctx.participateCityId == null ? undefined : String(ctx.participateCityId)) ?? base.cityId ?? REC_FALLBACK_CITY_ID,
        locateCityId: base.locateCityId ?? REC_FALLBACK_CITY_ID,
        // 客户端核心参数 utm_*（rec 专属，getRecExtraParams 派生），对齐接口文档与同仓 tex 组件
        utm_campaign: recExtra.utmCampaign,
        utm_content: recExtra.utmContent,
        utm_medium: recExtra.utmMedium,
        utm_source: recExtra.utmSource,
        utm_term: recExtra.utmTerm,
        version_name: base.version,
        // R007 3.18 新增入参：设备端 + 民宿来源端（rec 专属，getRecExtraParams 派生）
        source4Homestay: recExtra.source4Homestay,
        client: recExtra.client
    };
}
